import React from "react";
import Image from "next/image";

function ReviewStarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
    >
      <path
        d="M7.81929 0.938716L8.99262 3.24537C9.15262 3.56647 9.57929 3.87446 9.93929 3.93343L12.066 4.28074C13.426 4.50354 13.746 5.47339 12.766 6.43012L11.1126 8.05526C10.8326 8.33049 10.6793 8.86128 10.766 9.24135L11.2393 11.2531C11.6126 12.8455 10.7526 13.4615 9.31929 12.6293L7.32595 11.4694C6.96595 11.2597 6.37262 11.2597 6.00596 11.4694L4.01262 12.6293C2.58595 13.4615 1.71929 12.8389 2.09262 11.2531L2.56595 9.24135C2.65262 8.86128 2.49929 8.33049 2.21929 8.05526L0.565955 6.43012C-0.407378 5.47339 -0.0940448 4.50354 1.26596 4.28074L3.39262 3.93343C3.74595 3.87446 4.17262 3.56647 4.33262 3.24537L5.50596 0.938716C6.14596 -0.312905 7.18595 -0.312905 7.81929 0.938716Z"
        fill="#FAC220"
      />
    </svg>
  );
}

function ReviewLoveIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
    >
      <path
        d="M7.6995 12.9343C7.453 13.0219 7.047 13.0219 6.8005 12.9343C4.698 12.2112 0 9.19494 0 4.08258C0 1.82584 1.80525 0 4.031 0C5.3505 0 6.51775 0.642697 7.25 1.63596C7.98225 0.642697 9.15675 0 10.469 0C12.6948 0 14.5 1.82584 14.5 4.08258C14.5 9.19494 9.802 12.2112 7.6995 12.9343Z"
        fill="#FF3366"
      />
    </svg>
  );
}

function TwitterIcon({ width = 20, height = 17 }) {
  return (
    <Image
      src="/assets/pet-tag/twitter.png"
      width={width}
      height={height}
      alt="twitter"
    />
  );
}

function DarazIcon({ width = 20, height = 20 }) {
  return (
    <Image
      src="/assets/pet-tag/daraz.png"
      width={width}
      height={height}
      alt="twitter"
    />
  );
}

function ChaldalIcon({ width = 20, height = 20 }) {
  return (
    <Image
      src="/assets/pet-tag/chaldal.png"
      width={width}
      height={height}
      alt="twitter"
    />
  );
}

function FacebookIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M20 14.19C20 17.83 17.83 20 14.19 20H13C12.45 20 12 19.55 12 19V13.23C12 12.96 12.22 12.73 12.49 12.73L14.25 12.7C14.39 12.69 14.51 12.59 14.54 12.45L14.89 10.54C14.92 10.36 14.78 10.19 14.59 10.19L12.46 10.22C12.18 10.22 11.96 10 11.95 9.73001L11.91 7.28C11.91 7.12 12.04 6.98001 12.21 6.98001L14.61 6.94C14.78 6.94 14.91 6.81001 14.91 6.64001L14.87 4.23999C14.87 4.06999 14.74 3.94 14.57 3.94L11.87 3.98001C10.21 4.01001 8.89001 5.37 8.92001 7.03L8.97 9.78C8.98 10.06 8.76001 10.28 8.48001 10.29L7.28 10.31C7.11 10.31 6.98001 10.44 6.98001 10.61L7.01001 12.51C7.01001 12.68 7.14 12.81 7.31 12.81L8.51001 12.79C8.79001 12.79 9.00999 13.01 9.01999 13.28L9.10999 18.98C9.11999 19.54 8.66999 20 8.10999 20H5.81C2.17 20 0 17.83 0 14.18V5.81C0 2.17 2.17 0 5.81 0H14.19C17.83 0 20 2.17 20 5.81V14.19Z"
        fill="#3773E6"
      />
    </svg>
  );
}

function TrustpilotIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_2002_2482)">
        <path
          d="M19.9982 7.7612H12.3623L10.0037 0.5L7.6378 7.7612L0.00195312 7.75396L6.18588 12.246L3.81975 19.5L10.0037 15.0152L16.1801 19.5L13.8215 12.246L19.9982 7.7612Z"
          fill="#00B67A"
        />
        <path
          d="M14.3524 13.8884L13.8217 12.2461L10.0039 15.0152L14.3524 13.8884Z"
          fill="#005128"
        />
      </g>
      <defs>
        <clipPath id="clip0_2002_2482">
          <rect
            width="20"
            height="19"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

const iconMap = {
  facebook: FacebookIcon,
  twitter: TwitterIcon,
  trustpilot: TrustpilotIcon,
  daraz: DarazIcon,
  chaldal: ChaldalIcon,
  star: ReviewStarIcon,
  love: ReviewLoveIcon,
};

export {
  ReviewStarIcon,
  ReviewLoveIcon,
  TwitterIcon,
  FacebookIcon,
  TrustpilotIcon,
  DarazIcon,
  ChaldalIcon,
  iconMap,
};
